import React from 'react';
import { Row, Col, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Button, Label } from 'reactstrap';
import MaskedInput from 'react-maskedinput';
import * as utility from '../data/Utility';
import DropdownSelection from '../data/DropDown';
import moment from 'moment';


export const multipleChoiceTypes = {
    radio: "Radio",
    checkbox: "Checkbox",
};


export function hashCode(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
	const h1_shift16 = h1>>>16;
	const h2_shift16 = h2>>>16;
	const h1_shift13 = h1>>>13;
	const h2_shift13 = h2>>>13;
    h1 = Math.imul(h1 ^ h1_shift16, 2246822507) ^ Math.imul(h2 ^ h2_shift13, 3266489909);
    h2 = Math.imul(h2 ^ h2_shift16, 2246822507) ^ Math.imul(h1 ^ h1_shift13, 3266489909);
	return (h2>>>0).toString(16).padStart(8,0)+(h1>>>0).toString(16).padStart(8,0);	// return string
    // return 4294967296 * (2097151 & h2) + (h1>>>0);	// return integer
}


export const inputTypes = {
    date: "date",
    password: "password",
    radio: "radio",
    checkbox: "checkbox",
    text: "text",
    textarea: "textarea",
    hm: "hm",
    hms: "hms",
    time: "time"
}

export function getOptional() {
    return <i><small> - Optional</small></i>;
}

export function getCrfGroup(label, className, optional, inputs, onDeleteFunc, isDisabled ) {
    var id = "";
    if (inputs[0] != null) {
        id = inputs[0].id;
    }

    return (
        <div className={className} key={id+"_"+hashCode(label+id)}>
			<Label className="bold" for={id}>{label}{optional && getOptional()}</Label>
			<Button color="danger" className="button deleteButton" disabled={isDisabled} onClick={onDeleteFunc.bind(this, label)}>Delete</Button>
			{inputs}
        </div>
    );
}

export function getFormGroup(label, optional, firstInput, secondInput) {
    var id = "";
    if (firstInput != null) {
        id = firstInput.id;
    }

    return (
        <FormGroup>
            <Label for={id}>{label}{optional && getOptional()}</Label>
            {firstInput}
            {secondInput}
        </FormGroup>
    );
}

export function getInputForCRF(id, label, isDisabled, isHidden, className, onSelect, onChange, onKeyDown, type, value, selections, selectionsValues) {
    var readOnly = false;
    if (onChange == null) {
        readOnly = true;
    }
    if (value == null) {
        value = "";
    }

    if (type === inputTypes.date) {
        value = utility.formatInputDate(value);
    }
    else if (type === inputTypes.time) {
		value = moment(value).format("hh:mm:ss");
    }

	className = "crf " + className;
    if (isHidden) {
		className += " hidden";
    }

    if (selectionsValues == null) {
        selectionsValues = [];
        selectionsValues.push(multipleChoiceTypes.radio);
    }

	return (
		<Row key={"row"+id}>
			<Col lg="4">
				<Label for={id}>{label}</Label>
				&nbsp;
				{onSelect !== null && <DropdownSelection className={className} disabled={isDisabled} selections={selections} values={selectionsValues} onSelect={onSelect} /> }
			</Col>
			<Col>
				<Input key={hashCode(label+id)} className={className} disabled={isDisabled} id={id} onChange={onChange} onKeyDown={onKeyDown} readOnly={readOnly} type={type} value={value} />
			</Col>
		</Row>
	);
}

export function getInput(id, disabled, onChange, onKeyDown, type, value, valid) {
    var readOnly = false;
    if (onChange == null) {
        readOnly = true;
    }
    if (value == null) {
        value = "";
    }

	if (type === inputTypes.hm) {
		if ( /^\d*$/.test(value) ) {
			value = utility.formatHm(value);
		}
		let mask = "11:11";
		let placeholder = "00:00";
        return (
            <MaskedInput className="input" disabled={disabled} mask={mask} placeholder={placeholder} id={id} onChange={onChange} onKeyDown={onKeyDown} readOnly={readOnly} type={type} value={value} />
        );
    }
    else if (type === inputTypes.hms) {
		if ( /^\d*$/.test(value) ) {
			value = utility.formatHms(value);
		}
		let mask = "11:11:11";
		let placeholder = "00:00:00";
        return (
            <MaskedInput className="input" disabled={disabled} mask={mask} placeholder={placeholder} id={id} onChange={onChange} onKeyDown={onKeyDown} readOnly={readOnly} type={type} value={value} />
        );
    }

    // No input validity
    if (valid == null) {
        return (
            <Input className="input" disabled={disabled} id={id} onChange={onChange} onKeyDown={onKeyDown} readOnly={readOnly} type={type} value={value} />
        );
    }
    // Valid input
    if (valid) {
        return (
            <Input disabled={disabled} id={id} onChange={onChange} onKeyDown={onKeyDown} readOnly={readOnly} type={type} valid value={value} />
        );
    }
    // Invalid input
    return (
        <Input disabled={disabled} id={id} invalid onChange={onChange} onKeyDown={onKeyDown} readOnly={readOnly} type={type} value={value} />
    );
}

export function getInputGroup(input, appendText) {
    return (
        <InputGroup>
            {input}
            <InputGroupAddon addonType="append">
                <InputGroupText>{appendText}</InputGroupText>
            </InputGroupAddon>
        </InputGroup>
    );
}

export function getRadioFormGroup(label, optional, firstRadio, secondRadio, thirdRadio) {
    return (
        <FormGroup tag="fieldset">
            <Label>{label}{optional && getOptional()}</Label>
            {firstRadio}
            {secondRadio}
            {thirdRadio}
        </FormGroup>
    );
}

export function getRadioInput(name, checked, disabled, onChange, onKeyDown, value) {
    var readOnly = false;
    if (onChange == null) {
        readOnly = true;
    }
    return (
        <FormGroup check key={hashCode(name+value)}>
            <Label check>
                <Input id={name+"_"+value} className="input" checked={checked} disabled={disabled} name={name} onChange={onChange} onKeyDown={onKeyDown} readOnly={readOnly} type={inputTypes.radio} />{' '}
                {value}
            </Label>
        </FormGroup>
    );
}

export function getCheckboxInput(name, checked, disabled, onChange, onKeyDown, value) {
    var readOnly = false;
    if (onChange == null) {
        readOnly = true;
    }
    return (
        <FormGroup check key={hashCode(name+value)}>
            <Label check>
                <Input className="input" checked={checked || false} disabled={disabled} name={name} onChange={onChange} onKeyDown={onKeyDown} readOnly={readOnly} type={inputTypes.checkbox} />{' '}
                {value}
            </Label>
        </FormGroup>
    );
}



// WEBPACK FOOTER //
// ./src/data/Elements.js